import useGetParsedCvData from './use-get-parsed-cv-data';

export default useGetParsedCvData;
